/**
 *    Favorites
 */

(function ($) {
  Drupal.behaviors.favoritesButton = {
    attach(context, settings) {
      const $body = $(document.body);

      // Workaround for direct enquiry by servicepartner and incentive
      // Before redirecting to the request form, the node needs to be added as favorite
      // @ToDo: Can this be done better via backend?
      $(document.body).on('click', '.vb-button--direct-request', function (e) {
        e.preventDefault();

        const $button = $(this);
        const href = $button.attr('href');

        const $heart = $('.vb-favorite-button');
        if (!$heart.hasClass('vb-active')) {
          $heart.click();
        }

        setTimeout(() => {
          window.location.href = href;
        }, 500);
      });

      // @ToDo: Cleanup!
      $(document.body).on('click', '.vb-favorite-button', function (e) {
        e.preventDefault();

        // clicked heart
        const $heart = $(this);
        const heartPositionTop = $heart[0].getBoundingClientRect().top;
        const heartPositionLeft = $heart[0].getBoundingClientRect().left;

        const favoriteId = $heart.attr('data-favorite-id');
        const flagUrl = $heart.attr('data-flag-url');
        const unflagUrl = $heart.attr('data-unflag-url');
        const flagAction = $heart.attr('data-flag-action');

        let ajaxUrl = flagUrl;
        if (flagAction === 'unflag') {
          ajaxUrl = unflagUrl;
        }
        $.ajax({
          url: ajaxUrl,
          beforeSend() {
            $heart.prop('disabled', true);
          },
          complete() {
            $heart.prop('disabled', false);
          },
          fail(jqXHR, textStatus) {
            console.log(`"To favorites" request failed: ${textStatus}`);
          },
        });

        const $targetCounter = $('.vb-favorite-target__counter');
        let targetCount = parseInt($targetCounter[0].innerText);

        if (flagAction === 'flag') {
          targetCount++;
          $heart.attr('data-flag-action', 'unflag');
        } else {
          targetCount--;
          $heart.attr('data-flag-action', 'flag');
        }

        // toggle connected heart with same favorite id (on map for example)
        $(`[data-favorite-id="${favoriteId}"]`).not(this).toggleClass('vb-active');

        // toggle 'active' class
        $heart.toggleClass('vb-active');

        // target heart
        const $target = $('.vb-favorite-target__body:visible');
        const targetPositionTop = $target[0].getBoundingClientRect().top;
        const targetPositionLeft = $target[0].getBoundingClientRect().left;
        const ariaRegionPopupTitle = $heart.closest('.vb-card').length ? $heart.closest('.vb-card').find('.vb-headline__title').text() : $heart.closest('.vb-headline').find('.vb-headline__title').text();

        if ($heart.hasClass('vb-active')) {
          // a11y
          $heart.find('.vb-favorite-button__title--add').attr('aria-hidden', 'true');
          $heart.find('.vb-favorite-button__title--remove').attr('aria-hidden', 'false');

          // a11y
          Drupal.behaviors.favoritesButton.ariaRegionPopup(`${ariaRegionPopupTitle.trim()} ${Drupal.t('was successfully added to favorites')}`);

          // create cloned heart
          const $heartClone = $heart.clone().addClass('vb-clone').css({
            top: heartPositionTop + 10, // + 10px margin
            left: heartPositionLeft + 10, // + 10px margin
          });

          // append cloned heart to dom
          $heartClone.appendTo($body);

          // delay and start animation
          setTimeout(() => {
            $heartClone.css({
              top: targetPositionTop,
              left: targetPositionLeft,
            });
          }, 0);

          // remove cloned heart after animation time
          setTimeout(() => {
            // remove clone
            $heartClone.remove();

            // add 'active' class to target
            $target.addClass('vb-active');

            $targetCounter.each(function () {
              $(this).html(targetCount);
            });

            setTimeout(() => {
              $target.removeClass('vb-active');
            }, 600); // double transition time
          }, 700); // double transition time + a bit more
        } else {
          // a11y
          $heart.find('.vb-favorite-button__title--add').attr('aria-hidden', 'false');
          $heart.find('.vb-favorite-button__title--remove').attr('aria-hidden', 'true');

          // a11y
          Drupal.behaviors.favoritesButton.ariaRegionPopup(`${ariaRegionPopupTitle.trim()} ${Drupal.t('was successfully removed from favorites')}`);

          $targetCounter.each(function () {
            $(this).html(targetCount);
          });
        }
      });
    },

    ariaRegionPopup(text) {
      if (text) {
        const $ariaRegionPopup = $('#vb-region-popup');
        const $ariaRegionPopupText = $ariaRegionPopup.find('.vb-region-popup__text');
        $ariaRegionPopupText.text(text);
      }
    },
  };
}(jQuery));

// end of favorites.js
